import { Modal } from "@leagueplatform/genesis-core";
import { QUERY_PARAM_KEYS, QUERY_PARAM_MODAL_VALUE } from "common/constants";
import { AccountDeletedModal } from "components/modals/account-deleted-modal.component";
import { DeleteAccountModal } from "components/modals/delete-account-modal.component";
import { useUrlParam } from "hooks/use-url-param/use-url-param.hook";

type Entry = { Component: React.ElementType };

const PRIVATE_MAPPING: Record<string, Entry | undefined> = {
  [QUERY_PARAM_MODAL_VALUE.REMOVE_PERSONALIZATION]: {
    Component: DeleteAccountModal,
  },
};

const PUBLIC_MAPPING: Record<string, Entry | undefined> = {
  [QUERY_PARAM_MODAL_VALUE.PERSONALIZATION_REMOVED_DISCLAIMER]: {
    Component: AccountDeletedModal,
  },
};

export const QueryParamModal = ({ isPublic }: { isPublic?: boolean }) => {
  const { urlParam, removeParam } = useUrlParam(QUERY_PARAM_KEYS.MODAL, true);
  const mapping = isPublic ? PUBLIC_MAPPING : PRIVATE_MAPPING;

  if (!urlParam) return null;
  const entry = mapping[urlParam];
  if (!entry) return null;
  const { Component } = entry;

  return (
    <Modal.Root open onOpenChange={removeParam}>
      <Component onClose={removeParam} />
    </Modal.Root>
  );
};
